import Flickity from 'flickity';
import imagesloaded from 'flickity-imagesloaded'; // eslint-disable-line no-unused-vars

export default () => {
    const gallery = document.querySelectorAll('.image-gallery');

    const initialize = (el) => {
        const items = el.querySelector('.image-gallery__items');
        const content = el.querySelectorAll('.image-gallery__content');
        const cursor = el.querySelector('.image-gallery__cursor');
        let carousel;

        function handleMouseMove(e) {
            // Flip cursor based on position
            const sectionRect = el.getBoundingClientRect();
            cursor.style.setProperty('--x', e.clientX + 'px');
            cursor.style.setProperty('--y', e.clientY - sectionRect.top + 'px');
            cursor.style.setProperty('--icon-scale', e.clientX > window.innerWidth / 2 ? 1 : -1);

            // Disable cursor if over content
            if (e.target.closest('.image-gallery__image') !== null) {
                handleMouseenter();
            } else {
                handleMouseLeave();
            }
        }

        function handleMouseenter() {
            cursor.style.setProperty('--opacity', 1);
            cursor.style.setProperty('--scale', 1);
        }

        function handleMouseLeave() {
            cursor.style.setProperty('--opacity', 0);
            cursor.style.setProperty('--scale', 0);
        }

        function handleClick(e) {
            if (e.target.closest('.image-gallery__image') !== null) {
                if (e.clientX > window.innerWidth / 2) {
                    carousel.next();
                } else {
                    carousel.previous();
                }
            }
        }

        function handleResize() {
            let maxHeight = 0;

            content.forEach((contentItem) => {
                if (contentItem.offsetHeight > maxHeight) {
                    maxHeight = contentItem.offsetHeight;
                }
            });

            el.style.setProperty('--content-height', `${maxHeight}px`);
        }

        function handleChange(index) {
            content.forEach((contentItem) => {
                contentItem.classList.remove('is-active');
            });

            const contentArray = Array.from(content);
            contentArray[index].classList.add('is-active');
        }

        if (items.children.length > 1) {
            carousel = new Flickity(items, {
                cellAlign: 'center',
                contain: true,
                prevNextButtons: false,
                pageDots: false,
                wrapAround: true,
                adaptiveHeight: false,
                imagesLoaded: true,
                resize: true,
                draggable: false,
                initialIndex: 1,
            });

            el.addEventListener('mousemove', handleMouseMove);
            el.addEventListener('mouseenter', handleMouseenter);
            el.addEventListener('mouseleave', handleMouseLeave);
            el.addEventListener('click', handleClick);

            carousel.on('change', handleChange);
        }

        window.addEventListener('resize', handleResize);
        handleResize();
    };

    for (const el of gallery) {
        initialize(el);
    }
};
